const SET_GLOBAL_PROPERTY = "SET_GLOBAL_PROPERTY";
const UNSET_GLOBAL_PROPERTY = "UNSET_GLOBAL_PROPERTY";
export function setGlobalProperty({ name = "", value = "" } = {}) {
    return {
        type: SET_GLOBAL_PROPERTY,
        payload: {
            name,
            value
        }
    };
}

export function unsetGlobalProperty({ name = "" } = {}) {
    return {
        type: UNSET_GLOBAL_PROPERTY,
        payload: {
            name
        }
    };
}
